import { SyntheticEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useNavigate, useSearchParams } from 'react-router'

import { useNotifications } from 'app/application/application'
import { PublicRoutes } from 'app/application/types'
import { combineClassnames } from 'app/common/presentation'
import { ArrowLeftIcon, CheckmarkIcon, NewPasswordIcon } from 'app/common/presentation/icons'
import { useUser } from 'app/user/application'

import { Button, Headline, Input } from 'components'

import accessStyles from '../AccessPage/AccessPage.module.scss'
import { validatePassword } from '../validatePassword'
import styles from './CreateNewPassword.module.scss'

const CreateNewPassword = () => {
  const navigate = useNavigate()
  const { te } = useNotifications()
  const [searchParams] = useSearchParams()
  const { t } = useTranslation('user')

  const { resetPassword } = useUser()

  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [showSuccess, setShowSuccess] = useState(false)

  const uuid = searchParams.get('id')

  if (!uuid) {
    return <Navigate to={PublicRoutes.ResetPassword} replace />
  }

  const handlePasswordReset = (e: SyntheticEvent) => {
    e.preventDefault()

    const passwordError = validatePassword(newPassword, confirmPassword)
    if (passwordError) {
      setError(te(`password.${passwordError}`))
    } else {
      void resetPassword(newPassword, uuid).then((result) => {
        if (result.ok) {
          setShowSuccess(true)
        } else {
          setError(result.val.message)
        }
      })
    }
  }

  return (
    <div
      className={combineClassnames(accessStyles.access, showSuccess ? styles.success : undefined)}
    >
      {showSuccess ? (
        <div>
          <CheckmarkIcon />
          <div>
            <Headline>{t('createNewPassword.success.title')}</Headline>
            <div className={styles.description}>{t('createNewPassword.success.description')}</div>
          </div>
          <Button leftIcon={<ArrowLeftIcon />} onClick={() => void navigate(PublicRoutes.Login)}>
            {t('createNewPassword.success.backToLogin')}
          </Button>
        </div>
      ) : (
        <div className={styles.createNewPassword}>
          <div>
            <NewPasswordIcon />
            <Headline>{t('createNewPassword.title')}</Headline>
            <div className={styles.description}>{t('createNewPassword.description')}</div>
          </div>
          <form onSubmit={handlePasswordReset}>
            <Input
              autoComplete="username"
              autoFocus
              error={error ? ' ' : undefined}
              label={t('createNewPassword.newPassword')}
              mandatory
              onChange={setNewPassword}
              placeholder={t('createNewPassword.placeholder.password')}
              type="password"
              value={newPassword}
            />
            <Input
              autoComplete="new-password"
              error={error}
              label={t('createNewPassword.confirmNewPassword')}
              mandatory
              onChange={setConfirmPassword}
              placeholder={t('createNewPassword.placeholder.password')}
              type="password"
              value={confirmPassword}
            />
            <Button disabled={!newPassword && !confirmPassword} type="submit">
              {t('createNewPassword.confirm')}
            </Button>
          </form>
        </div>
      )}
    </div>
  )
}

export default CreateNewPassword

// http://localhost:5173/create-new-password?id=53fe23f9-5563-47a8-83bf-2f3b8db4ac50
